var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observable, action, makeObservable } from 'mobx';
import UserActionsAPI from '../services/UserActionsAPI';
import { transformDataForVehicles } from '../framework/DataTransformers';
class NotFoundStore {
    constructor() {
        Object.defineProperty(this, "recommendationCars", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: observable([])
        });
        Object.defineProperty(this, "statsData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: observable.map({})
        });
        Object.defineProperty(this, "getRecommendationCars", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => {
                return UserActionsAPI.getPublicRecommendation()
                    .then((cars) => {
                    for (let i = 0; i < cars.length; i++) {
                        this.recommendationCars.push(transformDataForVehicles(cars[i]));
                    }
                })
                    .catch((error) => {
                    return error;
                });
            }
        });
        Object.defineProperty(this, "getStatsData", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (carIds) => {
                const recommendationCarIds = this.recommendationCars.map((carObj) => carObj.id);
                UserActionsAPI.getStatsData(carIds || recommendationCarIds)
                    .then((response) => {
                    response.data.forEach((objStats) => {
                        this.statsData.set(objStats.carId, objStats);
                    });
                })
                    .catch((error) => error);
            }
        });
        makeObservable(this);
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], NotFoundStore.prototype, "recommendationCars", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], NotFoundStore.prototype, "statsData", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], NotFoundStore.prototype, "getRecommendationCars", void 0);
__decorate([
    action,
    __metadata("design:type", Object)
], NotFoundStore.prototype, "getStatsData", void 0);
export default new NotFoundStore();
